import "client-only"

import { FlowKey, flowsMapping } from "@/config/flows"
import { usePathname } from "next/navigation"
import { PushNavigateOptions, useConfigParams, useNavigation } from "."

const useFlow = () => {
  /*--------------------hooks--------------------*/
  const { flow } = useConfigParams()
  const pathName = usePathname()
  const router = useNavigation()

  /*--------------------config--------------------*/
  const actualFlowName = flow as FlowKey
  const currentFlow = flowsMapping[actualFlowName]
  const currentStep = currentFlow?.find((step) => pathName === step.path)

  const initialFlowPath = {
    C1: "/",
    OCR: "/",
  }[actualFlowName || "C1"]

  /*--------------------helpers--------------------*/

  const goToFirstStep = () => router.replace(initialFlowPath)
  const goToNextStep = (options?: PushNavigateOptions) =>
    router.push(currentStep?.nextStepPath || "/error?flow=no-flow", options)
  const goToPrevStep = () =>
    router.push(currentStep?.prevStepPath || "/error?flow=no-flow")
  const findMultiStepPath = (step: string) =>
    currentFlow.find((flowStep) => flowStep.path.includes(step))?.path ||
    "/error?flow=no-flow"

  return {
    currentFlow,
    actualFlowName,
    initialFlowPath,
    goToFirstStep,
    goToNextStep,
    goToPrevStep,
    findMultiStepPath,
  }
}

export { useFlow }
